module.exports = __webpack_public_path__ + "img/img-banner-faqs.1206ed6c.png";